import React from 'react';
import { connect } from 'react-redux';
import { closeAddQuestionDialog } from 'store/common/commonActions';
import { addQuestion } from 'store/reclamation/reclamationsActions';
import AddQuestionDialog from './AddQuestionDialog';


const AddQuestionDialogContainer = ({ open, reclamationId, isAdding, addQuestion, closeAddQuestionDialog }) => {

    const [text, setText] = React.useState("");
    const [fichiersIds, setFichiersIds] = React.useState([]);

    React.useEffect(() => {
        setText("");
        setFichiersIds([]);
    }, [open]);


    const handleClickSave = () => {
        addQuestion(reclamationId, text, fichiersIds);
    };
    const handleClickCancel = () => {
        closeAddQuestionDialog();
    };

    const handleChange = (e) => {
        if (e.target.name === "text") {
            setText(e.target.value);
        }
        if (e.target.name === "fichiersIds") {
            setFichiersIds(e.target.value);
        }
    };

    if (open !== true) return null;

    let sauvegardable = text !== undefined && text !== null && text.length > 0;

    return (
        <AddQuestionDialog
            open={open}
            onClickSave={handleClickSave}
            onClickCancel={handleClickCancel}
            reclamationId={reclamationId}
            text={text}
            onChange={handleChange}
            isAdding={isAdding}
            sauvegardable={sauvegardable}
        />
    );
}


const mapStateToProps = state => ({
    open: state.common.addQuestionDialogOpen,
    isAdding: state.common.question.isAdding,
    reclamationId: state.common.question.reclamationId
});

const mapDispatchToProps = dispatch => ({
    addQuestion: (reclamationId, text, fichiersIds) => dispatch(addQuestion(reclamationId, text, fichiersIds)),
    closeAddQuestionDialog: () => dispatch(closeAddQuestionDialog())
});

export default connect(mapStateToProps, mapDispatchToProps)(AddQuestionDialogContainer);